import React, { useState } from 'react';
import './Portfolio.css';

const Portfolio = ({ data }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="portfolio" id="portfolio">
      <div className="portfolio-container">
        <div className="portfolio-header">
          <p className="section-subtitle">{data.subtitle}</p>
          <h2 className="section-title">{data.title}</h2>
        </div>

        <div className="portfolio-grid">
          {data.images.map((image) => (
            <div 
              key={image.id} 
              className="portfolio-item"
              onClick={() => setSelectedImage(image)}
            >
              <img src={image.url} alt={image.title} className="portfolio-image" />
              <div className="portfolio-overlay">
                <p className="portfolio-title">{image.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content">
            <button className="lightbox-close" onClick={() => setSelectedImage(null)}>×</button>
            <img src={selectedImage.url} alt={selectedImage.title} />
            <p className="lightbox-title">{selectedImage.title}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
